import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    listPegawaiChanel = new Subject();
    createChannel = new Subject();
    listJabatanChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPegawai = async (query) => {
        this.listPegawaiChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchPegawai(query).then((result) => {
            this.listPegawaiChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listPegawaiChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    // fetchCategories = async (query) => {
    //     this.accategoriesChannel.next({status: apiResponse.LOADING})
    //     await this.repository.fetchCategories(query).then((result) => {
    //         this.accategoriesChannel.next({status: apiResponse.COMPLETED, data: result})
    //     }).catch((error) => {
    //         this.accategoriesChannel.next({status: apiResponse.ERROR, data: error})
    //     })
    // }

}

export default CreateBloc